import type { MeterStatsType, PaginationType } from "@/types"

import {
  meterDailyAnalyticsCountType,
  // MeterInfoAnalyticsType,
  MeterInfoType,
  MeterManagementAnalyticsType,
  MeterReaderType,
  MeterSizeRateType,
  MeterSizeType,
  MeterStatusType,
  SubmitMeterReader,
  SubmitMeterSizeType,
} from "@/types/meter"

import { getClientId } from "../auth"
import { apiFetch, formatDate } from "../utils"
import { postActivityLog } from "./log"

const billingUrl = `himo-billing/`
export async function getMeterDailyAnalyticsCount(
  fromDate: string | Date,
  toDate: string | Date,
): Promise<meterDailyAnalyticsCountType> {
  const formattedFromDate = formatDate(fromDate)
  const formattedToDate = formatDate(toDate)
  const response = await apiFetch(
    `${billingUrl}meter-daily-count/?from_date=${formattedFromDate}&to_date=${formattedToDate}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )
  if (!response.ok) {
    throw new Error(`Error fetching: ${response.statusText}`)
  }
  const jsonResponse = await response.json()
  return jsonResponse
}

export async function getMeterInfo(
  size: number,
  page: number,
  search: string,
): Promise<PaginationType<MeterInfoType>> {
  const clientId = getClientId()
  const response = await apiFetch(
    `${billingUrl}meter-info/?client_id=${clientId}&size=${size}&page=${page}&search=${search}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )
  if (!response.ok) {
    throw new Error(`Error fetching: ${response.statusText}`)
  }
  return response.json()
}
export async function deleteMeterSize(id: number) {
  const response = await apiFetch(`${billingUrl}meter-size/${id}/`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (!response.ok) {
    await postActivityLog({
      menu_path:
        "HIMO Billing-Digos Water District-Meter & Connection Settings",
      sub_menu_path: "/meter-connection-settings/meter-size",
      action: `Delete Meter Size (ID ${id})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    throw new Error(`Error fetching: ${response.statusText}`)
  }

  await postActivityLog({
    menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
    sub_menu_path: "/meter-connection-settings/meter-size",
    action: `Delete Meter Size (ID ${id})`,
    status_code: response.status,
    api_endpoint: response.url,
    web_url: window.location.href,
  })

  return response.json()
}
export async function deleteMeterReader(id: number) {
  const response = await apiFetch(`${billingUrl}meter-reader/${id}/`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (!response.ok) {
    await postActivityLog({
      menu_path:
        "HIMO Billing-Digos Water District-Meter & Connection Settings",
      sub_menu_path: "/meter-connection-settings/meter-reader",
      action: `Delete Meter Reader (${id})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    throw new Error(`Error: ${response.statusText}`)
  }

  await postActivityLog({
    menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
    sub_menu_path: "/meter-connection-settings/meter-reader",
    action: `Delete Meter Reader (${id})`,
    status_code: response.status,
    api_endpoint: response.url,
    web_url: window.location.href,
  })

  return response
}

export async function editMeterSize(data: object, id: number) {
  const response = await apiFetch(`${billingUrl}meter-size/${id}/`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })

  if (!response.ok) {
    await postActivityLog({
      menu_path:
        "HIMO Billing-Digos Water District-Meter & Connection Settings",
      sub_menu_path: "/meter-connection-settings/meter-size",
      action: `Edit Meter Size (ID ${id})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    throw new Error(`Error fetching: ${response.statusText}`)
  }

  await postActivityLog({
    menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
    sub_menu_path: "/meter-connection-settings/meter-size",
    action: `Edit Meter Size (ID ${id})`,
    status_code: response.status,
    api_endpoint: response.url,
    web_url: window.location.href,
  })

  return response.json()
}
export async function getUnassignedMeters(): Promise<MeterInfoType[]> {
  const clientId = getClientId()
  const response = await apiFetch(`${billingUrl}unassigned-meters`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
  if (!response.ok) {
    throw new Error(`Error fetching: ${response.statusText}`)
  }
  console.log("response.json>>>>>>>>>>>.", response)
  return response.json()
}
/*export async function getMeterSize(connectionTypeId: number) {
  const response = await apiFetch(
    `${billingUrl}meter-size?connection_type_id=${connectionTypeId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )
  if (!response.ok) {
    throw new Error(`Error fetching: ${response.statusText}`)
  }

  const data = await response.json()
  return data.map((item: MeterSizeType) => ({
    id: item.id,
    label: item.connection_type + " - Size: " + item.size,
    value: item.size,
  }))
}*/
export async function getMeterReaderById(id: number): Promise<MeterReaderType> {
  const response = await apiFetch(`himo-billing/meter-reader/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (!response.ok) {
    throw new Error(`Error fetching ${response.statusText}`)
  }

  return await response.json()
}
export async function getMeterSizeById(id: number): Promise<MeterSizeType> {
  const response = await apiFetch(`himo-billing/meter-size/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (!response.ok) {
    throw new Error(`Error fetching ${response.statusText}`)
  }

  return await response.json()
}

export async function getMeterSize(
  connection_type_id: number[],
): Promise<MeterSizeType[]> {
  // Convert the array to a JSON string
  const connectionTypeIdQuery =
    connection_type_id.length > 0
      ? `connection_type_id=${JSON.stringify(connection_type_id)}`
      : ``

  const response = await apiFetch(
    `himo-billing/meter-size/?${connectionTypeIdQuery}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (!response.ok) {
    throw new Error(`Error fetching ${response.statusText}`)
  }

  return await response.json()
}

export async function getMeterSizeRates(): Promise<
  PaginationType<MeterSizeRateType>
> {
  const response = await apiFetch(`himo-billing/meter-size/rates`)

  if (!response.ok) {
    throw new Error(`Error fetching ${response.statusText}`)
  }

  return await response.json()
}

//meter size dropdown
export async function getMeterSizeDropdown(
  connection_type_id: number[],
): Promise<MeterSizeType[]> {
  // Convert the array to a JSON string
  const connectionTypeIdQuery =
    connection_type_id.length > 0
      ? `connection_type_id=${JSON.stringify(connection_type_id)}`
      : ``

  const response = await apiFetch(
    `himo-billing/meter-size/?${connectionTypeIdQuery}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (!response.ok) {
    throw new Error(`Error fetching ${response.statusText}`)
  }

  //return await response.json()
  const data = await response.json()
  return data.map((meter: MeterSizeType) => ({
    id: meter.id,
    label: meter.size,
    value: meter.size,
  }))
}

export async function getConnectionType() {
  const response = await apiFetch(`himo-billing/connection-type/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (!response.ok) {
    throw new Error(`Error fetching ${response.statusText}`)
  }

  return await response.json()
}
export async function getUserDropDown() {
  const response = await apiFetch(`${billingUrl}add-meter-reader-dropdown/`)

  if (!response.ok) {
    throw new Error("Cannot fetch meter reader")
  }

  return response.json()
}
export async function getMeterReader() {
  const response = await apiFetch(`${billingUrl}meter-reader/?size=20`)

  if (!response.ok) {
    throw new Error("Cannot fetch meter reader")
  }

  return response.json()
}
export async function editMeterReader(data: object, id: number) {
  const response = await apiFetch(`${billingUrl}meter-reader/${id}/`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })

  if (!response.ok) {
    await postActivityLog({
      menu_path:
        "HIMO Billing-Digos Water District-Meter & Connection Settings",
      sub_menu_path: "/meter-connection-settings/meter-reader",
      action: `Edit Meter Reader (ID ${id})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    throw new Error(`Error: ${response.statusText}`)
  }

  await postActivityLog({
    menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
    sub_menu_path: "/meter-connection-settings/meter-reader",
    action: `Edit Meter Reader (ID ${id})`,
    status_code: response.status,
    api_endpoint: response.url,
    web_url: window.location.href,
  })

  return response.json()
}

export async function addMeterReader(data: SubmitMeterReader) {
  const response = await apiFetch(`${billingUrl}meter-reader/`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify(data),
  })

  if (!response.ok) {
    await postActivityLog({
      menu_path:
        "HIMO Billing-Digos Water District-Meter & Connection Settings",
      sub_menu_path: "/meter-connection-settings/meter-reader",
      action: `Add Meter Reader (${data.name_id})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    throw new Error(`Error: ${response.statusText}`)
  }

  await postActivityLog({
    menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
    sub_menu_path: "/meter-connection-settings/meter-reader",
    action: `Add Meter Reader (${data.name_id})`,
    status_code: response.status,
    api_endpoint: response.url,
    web_url: window.location.href,
  })

  return response.json()
}

export async function addMeterSizeRate(data: any) {
  const response = await apiFetch(`${billingUrl}meter-size/rates/create/`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify(data),
  })

  if (!response.ok) {
    await postActivityLog({
      menu_path:
        "HIMO Billing-Digos Water District-Meter & Connection Settings",
      sub_menu_path: "/meter-connection-settings/meter-size-rates",
      action: `Add Meter Size Rate (${data.meter_size})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    throw new Error(`Error: ${response.statusText}`)
  }

  await postActivityLog({
    menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
    sub_menu_path: "/meter-connection-settings/meter-size-rates",
    action: `Add Meter Size Rate (${data.meter_size})`,
    status_code: response.status,
    api_endpoint: response.url,
    web_url: window.location.href,
  })

  return response.json()
}

export async function addMeterSize(data: SubmitMeterSizeType) {
  const response = await apiFetch(`${billingUrl}meter-size/`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify(data),
  })

  if (!response.ok) {
    await postActivityLog({
      menu_path:
        "HIMO Billing-Digos Water District-Meter & Connection Settings",
      sub_menu_path: "/meter-connection-settings/meter-size",
      action: `Add Meter Size (${data.connection_type_id})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    throw new Error(`Error: ${response.statusText}`)
  }

  await postActivityLog({
    menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
    sub_menu_path: "/meter-connection-settings/meter-size",
    action: `Add Meter Size (${data.connection_type_id})`,
    status_code: response.status,
    api_endpoint: response.url,
    web_url: window.location.href,
  })

  return response.json()
}
export async function getMeterStatus() {
  const response = await apiFetch(`${billingUrl}meter-status/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
  if (!response.ok) {
    throw new Error(`Error fetching: ${response.statusText}`)
  }

  const data: {
    meter_status_id: string
    name: string
  }[] = await response.json()
  return data.map((item: { meter_status_id: string; name: string }) => ({
    id: item.meter_status_id,
    label: item.name,
    value: item.name,
  }))
}

export async function getMeterStatistics(
  days: number,
): Promise<MeterStatsType> {
  const response = await apiFetch(`${billingUrl}meter-stats/?days=${days}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (!response.ok) {
    throw new Error(`Error fetching: ${response.statusText}`)
  }

  const data = await response.json()

  return data
}

// export async function getMeterInfoAnalytics(
//   startDate: string,
//   endDate: string,
// ): Promise<MeterInfoAnalyticsType[]> {
//   const response = await apiFetch(
//     `${billingUrl}meter-info-analytics?from_date=${startDate}&to_date=${endDate}`,
//     {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//       },
//     },
//   )
//   if (!response.ok) {
//     throw new Error(`Error fetching: ${response.statusText}`)
//   }
//   return response.json()
// }

// meter-management-analytics
export async function getMeterManagementAnalytics(
  fromDate: string,
  toDate: string,
): Promise<MeterManagementAnalyticsType> {
  const formattedFromDate = formatDate(fromDate)
  const formattedToDate = formatDate(toDate)
  const response = await apiFetch(
    `${billingUrl}meter-management-analytics/?from_date=${formattedFromDate}&to_date=${formattedToDate}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  )

  if (!response.ok) {
    throw new Error(`Error fetching: ${response.statusText}`)
  }
  return response.json()
}

//this api use to retrieve meter status
export async function getMeterStatusList(): Promise<MeterStatusType[]> {
  const response = await apiFetch(`himo-billing/meter-status/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (!response.ok) {
    throw new Error(`Error fetching ${response.statusText}`)
  }

  return await response.json()
}

export async function addMeterStatus(data: MeterStatusType) {
  const response = await apiFetch(`${billingUrl}meter-status/create/`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify(data),
  })

  if (!response.ok) {
    await postActivityLog({
      menu_path:
        "HIMO Billing-Digos Water District-Meter & Connection Settings",
      sub_menu_path: "/meter-connection-settings/meter-status",
      action: `Add Meter Status (${data.meter_status_id})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    throw new Error(`Error: ${response.statusText}`)
  }

  await postActivityLog({
    menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
    sub_menu_path: "/meter-connection-settings/meter-status",
    action: `Add Meter Status (${data.meter_status_id})`,
    status_code: response.status,
    api_endpoint: response.url,
    web_url: window.location.href,
  })

  return response.json()
}

//this endpoint used to edit meter status

export async function editMeterStatus(data: MeterStatusType, id: number) {
  const response = await apiFetch(`${billingUrl}meter-status/update/${id}/`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })

  if (!response.ok) {
    await postActivityLog({
      menu_path:
        "HIMO Billing-Digos Water District-Meter & Connection Settings",
      sub_menu_path: "/meter-connection-settings/meter-status",
      action: `Edit Meter Status (ID ${id})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    throw new Error(`Error fetching: ${response.statusText}`)
  }

  await postActivityLog({
    menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
    sub_menu_path: "/meter-connection-settings/meter-status",
    action: `Edit Meter Status (ID ${id})`,
    status_code: response.status,
    api_endpoint: response.url,
    web_url: window.location.href,
  })

  return response.json()
}

//this endpoint used to delete meter status
export async function deleteMeterStatus(id: number) {
  const response = await apiFetch(`${billingUrl}meter-status/delete/${id}/`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  })

  console.log(response)

  if (!response.ok) {
    await postActivityLog({
      menu_path:
        "HIMO Billing-Digos Water District-Meter & Connection Settings",
      sub_menu_path: "/meter-connection-settings/meter-status",
      action: `Delete Meter Status (ID ${id})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    throw new Error(`Error fetching: ${response.statusText}`)
  }

  await postActivityLog({
    menu_path: "HIMO Billing-Digos Water District-Meter & Connection Settings",
    sub_menu_path: "/meter-connection-settings/meter-status",
    action: `Delete Meter Status (ID ${id})`,
    status_code: response.status,
    api_endpoint: response.url,
    web_url: window.location.href,
  })

  return true
}
